export default __webpack_public_path__ + "static/media/inner1.4b55fef4.jpg";